<template>
     <div class="flex flex-col mb-5">
        <h1 class="pl-3">{{ title }}</h1>
        <div class="">
            <nav class="-mb-2 w-full flex flex-row">
                <a v-for="tab in tabs"
                   class="no-underline text-xs leading-tight py-2 px-3 border-b-4 border-gray-100 rounded-t-md text-gray-700 mx-1"
                   :class="{ 'text-teal-700 bg-gray-100 text-sm font-bold': tab.isActive, 'bg-gray-300 text-grey-600': tab.isActive == false }"
                   :href="tab.href" @click="selectTab(tab)"
                   :key="tab.name"
                >
                    {{ tab.name }}
                </a>
            </nav>
            <div class="rounded-b-lg rounded-tr-lg bg-gray-100 p-3 border-4 border-gray-300 w-full">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: ''
    },
    data() {
        return { tabs: [] };
    },
    created() {
        this.tabs = this.$children;
    },
    methods: {
        selectTab(selectedTab) {
            this.tabs.forEach(tab => {
                tab.isActive = (tab.href == selectedTab.href);
            });
        }
    }
};
</script>